import React from 'react';
import { Helmet } from 'react-helmet';
import { Provider } from 'react-redux';
import { createStore } from '../../state/createStore';
import { initializeFirebase } from '@we-agile-you/firebase';
import { AuthSubscriber } from '@we-agile-you/retrospective-app';

// eslint-disable-next-line react/display-name,react/prop-types
// @ts-ignore
export default ({ element }) => {
  // Instantiating store in `wrapRootElement` handler ensures:
  //  - there is fresh store for each SSR page
  //  - it will be called only once in browser, when React mounts
  const store = createStore();

  if (typeof window !== 'undefined') {
    initializeFirebase();
  }

  return (
    <>
      <Helmet titleTemplate="Retrospective online | %s" />

      <Provider store={store}>
        <AuthSubscriber />
        {element}
      </Provider>
    </>
  );
};
